import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { completeAddressStep, completeDeliveryStep, completePaymentStep, finalizeCheckout, getStates, modifyCheckout, prepareCheckout, calculateShippingOptions } from '../redux/actions';
/**
 * The `useCheckout` hook returns functions for completing a checkout.
 *
 * @example
 *
 * ```javascript
 * import { useCheckout } from '@chordcommerce/react-autonomy'
 *
 * // inside a function component
 * const { finalizeCheckout } = useCheckout()
 * ```
 *
 * @category Hook
 */
export function useCheckout() {
  var dispatch = useDispatch();
  var actionDispatches = useMemo(function () {
    return bindActionCreators({
      completeAddressStep: completeAddressStep,
      completeDeliveryStep: completeDeliveryStep,
      completePaymentStep: completePaymentStep,
      finalizeCheckout: finalizeCheckout,
      getStates: getStates,
      modifyCheckout: modifyCheckout,
      prepareCheckout: prepareCheckout,
      calculateShippingOptions: calculateShippingOptions
    }, dispatch);
  }, [dispatch]);
  return actionDispatches;
}